import React from 'react';
import { PriorityMatrix } from './PriorityMatrix';
import { SearchIcon, ZapIcon, LinkIcon, TrendingUpIcon } from 'lucide-react';
const steps = [{
  number: '1',
  title: 'Discover & Value Map',
  description: 'Identify processes, map pains, estimate impact, and set guardrails.',
  icon: SearchIcon
}, {
  number: '2',
  title: 'Prototype Fast',
  description: 'Stand up an assistant, copilot, autopilot, or agent with real data.',
  icon: ZapIcon
}, {
  number: '3',
  title: 'Integrate & Automate',
  description: 'Embed into ERP/CRM/SCM and data platforms; add governance and controls.',
  icon: LinkIcon
}, {
  number: '4',
  title: 'Optimize & Learn',
  description: 'Close the loop with feedback, model updates, A/B tests, and ROI tracking.',
  icon: TrendingUpIcon
}];
export function ProcessSection() {
  return <section id="process" className="py-24 bg-white" data-id="element-122">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-123">
        <h2 className="section-title" data-id="element-124">How We Build Your Solution</h2>
        <p className="section-subtitle" data-id="element-125">
          Our process is designed to deliver measurable value quickly and scale
          responsibly, from initial idea to enterprise-grade deployment.
        </p>

        {/* 4-step approach */}
        <div className="mt-16" data-id="element-126">
          <h3 className="text-2xl font-bold text-center text-slate-900 mb-12" data-id="element-127">
            Our 4-Step Delivery Approach
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-128">
            {steps.map((step, index) => {
            const Icon = step.icon;
            return <div key={step.number} className="relative group" data-id="element-129">
                  <div className="card h-full transition-all duration-200 hover:shadow-xl hover:-translate-y-1" data-id="element-130">
                    <div className="flex flex-col items-center text-center" data-id="element-131">
                      <div className="flex items-center justify-center h-16 w-16 rounded-full bg-gradient-to-br from-blue-600 to-blue-700 text-white font-bold text-2xl shadow-lg mb-4" data-id="element-132">
                        {step.number}
                      </div>
                      <Icon className="w-8 h-8 text-blue-600 mb-3" data-id="element-133" />
                      <h4 className="text-lg font-bold text-slate-900 mb-2" data-id="element-134">
                        {step.title}
                      </h4>
                      <p className="text-slate-600 text-sm leading-relaxed" data-id="element-135">
                        {step.description}
                      </p>
                    </div>
                  </div>
                  {index < steps.length - 1 && <div className="hidden lg:block absolute top-1/2 -right-3 transform -translate-y-1/2 text-2xl text-blue-600 z-10" data-id="element-136">
                      →
                    </div>}
                </div>;
          })}
          </div>
        </div>

        {/* Prioritize & Roadmap */}
        <div className="mt-20 grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-137">
          <div data-id="element-138">
            <h3 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-139">
              How We Prioritize & Roadmap
            </h3>
            <p className="text-slate-600 mb-6" data-id="element-140">
              We focus on what matters most. Initiatives are scored and plotted
              on a 2×2 to select the Top 3 pilots with the best balance of high
              impact and high feasibility.
            </p>
            <ul className="space-y-3 text-slate-700" data-id="element-141">
              <li className="flex items-start gap-3" data-id="element-142">
                <span className="flex-shrink-0 w-6 h-6 rounded-full bg-blue-600 text-white flex items-center justify-center text-sm font-bold" data-id="element-143">
                  1
                </span>
                <span data-id="element-144">
                  Score by <strong data-id="element-145">Impact</strong> (revenue/cost/risk) &{' '}
                  <strong data-id="element-146">Feasibility</strong> (data/integration).
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-147">
                <span className="flex-shrink-0 w-6 h-6 rounded-full bg-blue-600 text-white flex items-center justify-center text-sm font-bold" data-id="element-148">
                  2
                </span>
                <span data-id="element-149">Plot candidates on the matrix.</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-150">
                <span className="flex-shrink-0 w-6 h-6 rounded-full bg-blue-600 text-white flex items-center justify-center text-sm font-bold" data-id="element-151">
                  3
                </span>
                <span data-id="element-152">
                  Convert the Top 3 into a quarterly backlog with owners & KPIs.
                </span>
              </li>
            </ul>
          </div>
          <PriorityMatrix data-id="element-153" />
        </div>
      </div>
    </section>;
}